import React from "react";
import { cn } from "@/lib/utils";
import { SEVERITY_LABELS, type Severity } from "./verdictModel";

/** Verdict severity pill (Strong / Mixed / Weak), tinted off the status ramp.
 *  Mirrors the prototype's quiet `.badge-status` used in the verdict + qcards. */
export function SeverityBadge({ severity, className }: { severity: Severity; className?: string }) {
  return (
    <span className={cn("vb-sev", `vb-sev--${severity}`, className)}>
      {SEVERITY_LABELS[severity]}
    </span>
  );
}

export default SeverityBadge;
